import(/* webpackMode: "eager" */ "/vercel/path0/app/(not-town)/the-killers/page.tsx");
